import { UserCircleIcon } from '@heroicons/react/24/outline';
import { ReactNode, useRef } from 'react';

interface TimelineProps {
  items: {
    title: ReactNode;
    description?: ReactNode;
    icon?: ReactNode;
    updated?: string;
  }[];
}
export function Timeline(props: TimelineProps) {
  const lastItemRef = useRef<HTMLDivElement>(null);
  const lastItemHeight = lastItemRef.current?.clientHeight || 0;

  return (
    <div
      className="text-chariot-text-primary relative mx-4 flex flex-col gap-8 pt-4"
      data-testid="timeline"
    >
      <div
        className="bg-chariot-stroke absolute top-0 left-[27px] z-0 w-[2px]"
        style={{
          height: `calc( 100% - ${lastItemHeight / 2}px)`,
        }}
      ></div>
      {props.items.map((item, index) => {
        if (!item.title) {
          return null;
        }
        return (
          <div
            ref={index === props.items.length - 1 ? lastItemRef : undefined}
            key={index}
            className="flex gap-3"
          >
            <div className="bg-chariot-background-primary text-chariot-text-secondary z-10 flex items-center justify-center rounded-full *:size-14">
              {item.icon || <UserCircleIcon className="stroke-1" />}
            </div>
            <div className="flex flex-col gap-1">
              <div className="text-sm">{item.title}</div>
              <div
                className="text-chariot-text-secondary text-xs"
                data-testid="timeline-description"
                data-updated={item.updated}
              >
                {item.description}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
